import { useContext, createContext } from 'react';

export const EditorContext = createContext({});

export default function useEditorContext() {
  return useContext(EditorContext);
}



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useEditorContext.js